import React, { useEffect, useState } from 'react'
import DateConverter from '../Tools/DateConverter'
import { startOfWeek, addWeeks, getISOWeek } from 'date-fns'
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;

function ItemProyeccionDay(props) {
    const { sucursales, fecha, compl, idProducto } = props;
    const [fechaConv, setFechaConv] = useState('');
    const [loading, setLoading] = useState(false);
    const [reqSemanal, setReqSemanal] = useState([]);
    function obtenerDatos(nSemana, nAnio) {
        setLoading(true);
        var info = JSON.parse(localStorage.getItem('info'));
        var firstDayOfWeek = startOfWeek(new Date(nAnio, 0, 1)); // Inicio del año
        var fechaAconsultar = addWeeks(firstDayOfWeek, nSemana - 1);
        var fechafin = new Date(fechaAconsultar)
        fechafin.setDate(fechaAconsultar.getDate() + 7);
        fechaAconsultar.setDate(fechaAconsultar.getDate() + 1);
        const consulta = {
            fechaIni: DateConverter.formatoFechaNumeric(fechaAconsultar),
            fechaFin: DateConverter.formatoFechaNumeric(fechafin),
            sucursal: 0,
            regional: info.ID_REGIONAL_ACTUAL,
            semana: nSemana,
            anio: nAnio
        }
        console.log(consulta);
        try {
            fetch(`${server}/reporte/getReqSemanal`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(consulta)
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        var diaL = [...new Set(data.ok[0].DETALLE.map(item => item.DIA))];
                        console.log(data.ok);
                        //setListaDias(diaL);
                        setReqSemanal(data.ok);
                    } else {
                        MsgUtils.msgError(data.error)
                    }
                    setLoading(false);
                })
                .catch(err => console.log(err));
        } catch (error) {
            console.log(error.message)
        }
    }
    function getInformacion(sucursal) {
        var dia = fechaConv.split('-')
        var sucLista = reqSemanal.filter((item) => item.ID_SUCURAL == sucursal.ID_SUCURAL)
        var productos = sucLista[0].DETALLE.filter((item) => item.DIA == dia[2])
        console.log(sucLista, productos)
        if (idProducto == 0) {
            return (
                <i className="fa-solid fa-question "></i>
            )
        } else {
            return (
                <div className='container-fluid'>
                    {productos.map((item, index) => {
                        if (idProducto == item.ID_PRODUCTO) {
                            return (
                                <div className='text-center' key={index}>
                                    {item.CANTIDAD}
                                </div>
                            )
                        }
                    })}
                </div>
            )
        }
    }
    useEffect(() => {
        var fechaConvertida = DateConverter.getFechaSumadoDias(fecha, compl * 7)
        var particiones = fechaConvertida.split('-')
        setFechaConv(fechaConvertida)
        if (reqSemanal.length == 0) {
            obtenerDatos(DateConverter.getNumSemana(fechaConvertida), particiones[0])
        }
    }, [idProducto])
    return (
        <ul className="list-group">
            {loading == false &&idProducto!=0&& sucursales.map((item, index) => {
                return (
                    <li className="list-group-item bg-dark text-light bg-gradient" key={index}>{getInformacion(item)}</li>
                )
            })}
            {loading == false &&idProducto==0&&
                <li className="list-group-item bg-dark text-light bg-gradient text-center">
                    <i className="fa-solid fa-question "></i>
                </li>
            }
            {loading == false &&
                <li className="list-group-item bg-dark text-light bg-gradient" >{fechaConv}</li>}
            {loading == true &&
                <li className="list-group-item bg-dark text-light bg-gradient text-center">
                    <i className="fa-solid fa-spinner fa-spin-pulse"></i>
                </li>}
        </ul>
    )
}

export default ItemProyeccionDay